/** Mirrors `positions.Kind`, backend/core/omni/domain/positions/kind.go. */
export const PositionKind = {
  Default: "",
  Text: "text",
  AreaTitle: "area-title",
  GroupTitle: "group-title",
  Dynamic: "dynamic",
  PriceModifierRelative: "modifier-relative",
  PriceModifierAbsolute: "modifier-absolute",
  SubTotal: "subtotal",
  Total: "total",
};

export type PositionKind = (typeof PositionKind)[keyof typeof PositionKind];

export const PositionKindList = Object.values(PositionKind);

/**
 * isSumKind reports whether kind sums the positions before it, see
 * `positions.Kind.IsSum`, backend/core/omni/domain/positions/kind.go.
 */
export function isSumKind(kind: PositionKind): boolean {
  return kind === PositionKind.SubTotal || kind === PositionKind.Total;
}
